import React, { useContext } from 'react';
import homeicon from "./../../assets/ic--round-home.png";
import shopicon from "./../../assets/iconoir--shop.png";
import boxicon from "./../../assets/system-uicons--box.png";
import dataicon from "./../../assets/fluent--data-trending-28-filled.png";
import producticon from "./../../assets/mage--box-upload.png";
import marketing from "./../../assets/mdi--loudspeaker-outline.png";
import saleicon from "./../../assets/mdi--sale.png";
import developicon from "./../../assets/material-symbols--potted-plant-outline.png";
import financeicon from "./../../assets/carbon--finance.png";
import customericon from "./../../assets/streamline--information-desk-customer-solid.png";
import styles from './sellerpagefilterbar.module.css';
import { useNavigate } from 'react-router-dom';
import { NavigationContext } from "../../context/navigation";
import ImageWithFallback from '../ImageWithFallback';

const Sidebar = React.memo(() => {
  const navigate = useNavigate();
  const { open, setOpen } = useContext(NavigationContext);

  const handleClick = (type, path) => {
    setOpen({
      ...open,
      isHome: type === "isHome",
      isOrders: type === "isOrders",
      isProducts: type === "isProducts",
      isShop: type === "isShop",
      isCustomers: type === "isCustomers",
      isMarketing: type === "isMarketing",
      isFinance: type === "isFinance",
      isData: type === "isData",
      isDevelopment: type === "isDevelopment",
      isDiscount: type === "isDiscount",
    });
    navigate(path);
  };

  const menuItems = [
    { icon: homeicon, label: 'Trang chủ', type: 'isHome', path: '#' },
    { icon: boxicon, label: 'Quản lý đơn hàng', type: 'isOrders', path: '#' },
    { icon: producticon, label: 'Quản lý sản phẩm', type: 'isProducts', path: '#' },
    { icon: shopicon, label: 'Quản lý shop', type: 'isShop', path: '#' },
    { icon: customericon, label: 'Quản lý khách hàng', type: 'isCustomers', path: '#' },
    { icon: marketing, label: 'Kênh marketing', type: 'isMarketing', path: '#' },
    { icon: financeicon, label: 'Tài chính', type: 'isFinance', path: '#' },
    { icon: dataicon, label: 'Dữ liệu', type: 'isData', path: '#' },
    { icon: developicon, label: 'Phát triển', type: 'isDevelopment', path: '#' },
    { icon: saleicon, label: 'Chương trình giảm giá', type: 'isDiscount', path: '#' },
  ];

  return (
    <div className={styles.sidebar}>
      <ul className={styles.menu}>
        {menuItems.map(item => (
          <li className={styles.menuItemBox} key={item.type}>
            <div
              className={open[item.type] ? styles.menuItemActive : styles.menuItem}
              onClick={() => handleClick(item.type, item.path)}
            >
              <ImageWithFallback loading="lazy" src={item.icon} alt={item.label} className={styles.icon} />
              <span>{item.label}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
});

export default Sidebar;
